<template>
  <div id="modal-info-body">
    <h2 style="text-align: center;">Desempenho por Indicador</h2>

    <p>
      Este relatório apresenta o resultado dos indicadores detalhado por equipe
      com informações do valor do numerador, denominador e resultado. Ele trata
      de dados definitivamente liberados no SISAB e previsão de resultado
      calculada com base no e-SUS PEC ou Centralizador.
    </p>

    <h3>RECOMENDAÇÃO</h3>

    <p>
      O resultado dos indicadores por equipe liberado a cada quadrimestre fica
      com acesso restrito, ou seja, somente os profissionais que têm liberação
      do CPF ou o gestor municipal da APS pode ter acesso no
      <a href="https://acesso-egestoraps.saude.gov.br/login" target="_blank"
        >SISAB</a
      >.
    </p>
    <p>
      Para disponibilizar os
      <strong>resultados dos indicadores do último quadrimestre</strong>
      para os profissionais de saúde, o Administrador municipal do e-SUS pode
      baixar as planilhas e importar aqui no sistema. Essa ação pode ser feita
      em
      <strong>INÍCIO >> Administração >> Indicadores Previne Brasil</strong>. A
      importação desses dados pode acontecer sempre que o resultado do último
      quadrimestre for liberado no SISAB, na área de
      <a
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/indicadores/indicadorPainel.xhtml"
        target="_blank"
        >indicadores de desempenho</a
      >
      .
    </p>

    <h3>FUNCIONALIDADES</h3>

    <p>
      Para visualizar as informações, o usuário deve clicar na seta ao final da
      descrição de cada indicador. A tabela apresentada, mostra:
    </p>

    <ul>
      <li>
        <strong>Numerador - </strong>Quantidade de pessoas analisadas no
        indicador que atendem aos requisitos de acompanhamento estabelecidos na
        normativa vigente;
      </li>
      <li>
        <strong>Denominador - </strong>Público-alvo analisado no indicador;
      </li>
      <li>
        <strong>Resultado - </strong>É dado pela fórmula (Numerador /
        Denominador) *100;
      </li>
      <li>
        <strong>Quadrimestre - </strong>Final de abril (Q1), final de agosto
        (Q2) e final de dezembro (Q3);
      </li>
      <li>
        <strong>Status - </strong>As contas são feitas com base nos dados do
        e-SUS PEC (Previsão) ou os dados foram importados do SISAB (Definitivo);
      </li>
      <li>
        <strong>Fonte - </strong>Mostra se os dados utilizados nas contas
        (Numerador, Denominador e Resultado) são provenientes do SISAB ou do
        e-SUS PEC.
      </li>
    </ul>
    <br />
    <p><strong>Atenção!</strong></p>
    <br />
    <p>
      Se o resultado das duas linhas (Previsão e Definitivo) estiverem
      diferentes, analisando-se o mesmo quadrimestre, então é importante
      verificar se ocorreu reprovação de dados no SISAB. Essa verificação pode
      ser feita com acesso restrito no
      <a
        href="https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/federal/envio/RelValidacao.xhtml"
        target="_blank"
        >Relatório de Validação</a
      >
      considerando os quatro meses que compõe o quadrimestre avaliado.
    </p>
    <br />
    <p>
      <strong
        >Pode existir diferença de dados entre o e-SUS PEC ou Centralizador e o
        SISAB, pois para chegar no SISAB os dados passam por uma validação. Para
        mais informações, recomenda-se a leitura da
        <a
          href="http://189.28.128.100/dab/docs/portaldab/documentos/esus/relatorio_validacao_2_2021_nota.pdf"
          target="_blank"
          >Nota Técnica
        </a>
        que explica em detalhes o processo de validação.</strong
      >
    </p>
    <br />
    <p>
      Basicamente, a reprovação de dados no SISAB acontece por divergência entre
      as lotações dos profissionais de saúde no e-SUS PEC ou Centralizador e o
      cadastro no CNES. Para evitar essas reprovações, recomenda-se ao
      Administrador municipal do e-SUS, pelo menos uma vez por semana, aqui no
      sistema ir em
      <strong>INÍCIO >> Profissionais PEC CNES</strong>, esperar os dados
      carregar e verificar se tem divergências, as quais podem ser comunicadas
      ao Administrador do CNES para fazer as devidas adequações
    </p>
    <br />
    <p>
      É sempre recomendado, pelo menos uma vez por mês, importar o XML gerado
      pelo SISAB no sistema e-SUS PEC ou Centralizador para manter as lotações
      dos profissionais de saúde sempre atualizadas.
    </p>
    <br />
    <h2 class="notas-tecnicas">NOTAS TÉCNICAS</h2>
    <p>
      <strong>Apresentação do Conjunto dos 7 Indicadores Previne Brasil</strong>
    </p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_12.pdf"
        target="_blank"
        >Nota Técnica 12/2022</a
      >
       - Indicadores de Pagamento por Desempenho do Programa Previne Brasil
      (2022) de que trata a <a
        href="https://www.in.gov.br/en/web/dou/-/portaria-gm/ms-n-102-de-20-de-janeiro-de-2022-375495336"
        target="_blank"
        >Portaria GM/MS nº 102, de 20 de janeiro de 2022</a
      >, que alterou a <a
        href="https://www.in.gov.br/en/web/dou/-/portaria-n-3.222-de-10-de-dezembro-de-2019-232670481"
        target="_blank"
        >Portaria GM/MS nº 3.222, de 10 de dezembro de 2019</a
      >, que dispõe sobre os indicadores do pagamento por desempenho, no âmbito
      do Programa Previne Brasil.
    </p>
    <br />
    <p><strong>Indicador 1 – Pré-Natal</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_13.pdf"
        target="_blank"
        >Nota Técnica 13/2022</a
      > - Proporção de gestantes com pelo menos 6 (seis) consultas pré-natal
      realizadas, sendo a 1ª até a 12 ª semana de gestação.
    </p>
    <br />
    <p><strong>Indicador 2 – Sífilis e HIV</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_14.pdf"
        target="_blank"
        >Nota Técnica 14/2022</a
      > - Proporção de gestantes com realização de exames para sífilis e HIV.
    </p>
    <br />
    <p><strong>Indicador 3 – Pré-Natal Odontológico (PNO)</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_15.pdf"
        target="_blank"
        >Nota Técnica 15/2022</a
      > - Proporção de gestantes com atendimento odontológico realizado na
      Atenção Primária à Saúde.
    </p>
    <br />
    <p><strong>Indicador 4 – Citopatológico</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_16.pdf"
        target="_blank"
        >Nota Técnica 16/2022</a
      > - Proporção de mulheres com coleta de citopatológico na Atenção Primária
      à Saúde.
    </p>
    <br />
    <p><strong>Indicador 5 - Imunização</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_22.pdf"
        target="_blank"
        >Nota Técnica 22/2022</a
      > - Proporção de crianças de 1 (um) ano de idade vacinadas na APS contra
      Difteria, Tétano, Coqueluche, Hepatite B, infecções causadas
      por haemophilus influenzae tipo b e Poliomielite inativada.
    </p>
    <br />
    <p>
      <strong>Indicador 6 – Hipertensão Arterial Sistêmica (HAS)</strong>
    </p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_18.pdf"
        target="_blank"
        >Nota Técnica 18/2022</a
      > - Proporção de pessoas com hipertensão, com consulta e pressão arterial
      aferida no semestre.
    </p>
    <br />
    <p><strong>Indicador 7 – Diabetes (DM)</strong></p>
    <p>
      <a
        href="http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_23.pdf"
        target="_blank"
        >Nota Técnica 23/2022</a
      > - Proporção de pessoas com diabetes, com consulta e hemoglobina glicada
      solicitada no semestre.
    </p>
    <br />
  </div>
</template>
<script>
export default {
  name: 'Indicador',
}
</script>
<style scoped>
#modal-info {
  flex: 0 1 33%;
}

#modal-info button {
  width: 35px;
  height: 35px;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 0;
  float: right;
}

#modal-info-body h2 {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
#modal-info-body .notas-tecnicas {
  text-align: start;
  border-bottom: 1px solid #c1c1c1;
}
#modal-info-body h3 {
  font-size: 14px;
  font-weight: bold;
  margin: 20px 0;
}

#modal-info-body p {
  font-size: 14px;
  text-align: justify;
  margin-bottom: 0;
}

#modal-info-body ul {
  margin: 10px 25px 10px 25px;
  list-style-type: disc;
}

#modal-info-body ul li {
  font-size: 14px;
}

.modal-info-accessibility ul {
  display: inline-flex;
  margin: 10px 0 !important;
  padding: 0;
  gap: 5px;
}

.modal-info-accessibility ul li {
  border: 1px solid;
  list-style-type: none;
  padding: 5px;
  width: 30px;
  text-align: center;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 3px;
}

.modal-info-accessibility ul li a {
  color: #fff;
  font-size: 14px;
}

.modal-info-accessibility ul li a:hover {
  color: #000;
}
</style>

